import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, MenuItem, Select, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import TextEditor from 'src/components/CustomComponents/TextEditor';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { useMain } from '../hooks/useMain';
import { Cancel } from '@mui/icons-material';

const AddCategory = () => {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const initialValue = {
        name: '',
        description: '',
        image: {},
        subcategories: []
    };

    const [showPreview, setShowPreview] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMEssage, setSuccessMEssage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [formData, setFormData] = useState(initialValue);
    const [subCategoryValue, setSubCategoryValue] = useState('');

    const { addCategory } = useMain();

    const handleInputKeyPress = (event) => {
        if (event.key === 'Enter') {
            addSubcategory();
        }
    };

    const addSubcategory = () => {
        if (subCategoryValue.trim() !== '') {
            if (!formData?.subcategories?.includes(subCategoryValue))
                setFormData({ ...formData, subcategories: [...formData?.subcategories, subCategoryValue] });
            setSubCategoryValue('');
        }
    };

    const handleDeleteSubcategory = (item) => {
        const subcategories = formData?.subcategories?.filter((s) => s !== item);
        setFormData({ ...formData, subcategories })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
       
        setFormData({ ...formData, [name]: value });
    };

    const handleImage = (e) => {
       
        const objectUrl = URL.createObjectURL(e.target.files[0]);
        setShowPreview(objectUrl);
        setFormData({ ...formData, image: e.target?.files[0] });
    };
    const handleSubmit = async () => {
       
        if (formData.name.trim() === '') return setErrorMessage('Title is Required');
        if (editorState === '') return setErrorMessage('Description is Required');
        if (formData.image === null) return setErrorMessage('Image is required');
        if (formData.subcategories.length === 0) return setErrorMessage('Atleast one sub category is needed');
        const formDataUpdated = new FormData();
        formDataUpdated.append('name', formData.name);
        formDataUpdated.append('description', editorState);
        formDataUpdated.append('image', formData.image, formData.image.name);
        formDataUpdated.append('subCategory', formData.subcategories.join(','));
       
        setShowLoader(true);
        const res = await addCategory(formDataUpdated);
        // createBlog(formData, (res) => {
        if (res?.status === 'success') {
            setSuccessMEssage('Category Successfully Created');
            setTimeout(() => {
                setSuccessMEssage('');
            }, 7000);
            setFormData(initialValue);
            setErrorMessage('');
            setEditorState(EditorState.createEmpty());
            setShowLoader(false);
        } else {
            setErrorMessage(res?.error?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            setFormData(initialValue);
            setShowLoader(false);
        }
    };
    return (
        <PageContainer title="Add Category" description="this is add Category">
            <DashboardCard title="Add Category">
                <div style={{ border: '1px solid black', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1rem', borderRadius: '1rem' }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <input type="file" onChange={handleImage} />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        {showPreview && <img width="400px" height="300px" src={showPreview} />}
                    </div>
                </div>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Name <ReqField />
                    </Typography>
                    <CustomTextField
                        id="username"
                        variant="outlined"
                        fullWidth
                        value={formData?.name}
                        onChange={handleChange}
                        name="name"
                    />
                </Box>
                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Decription <ReqField />
                    </Typography>
                    <div
                        style={{
                            border: '1px solid gray',
                            padding: '10px',
                        }}
                    >
                        <TextEditor
                            convertedContent={editorState}
                            setConvertedContent={setEditorState}
                            setFormData={setFormData}
                            formData={formData}
                        />
                    </div>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={600}
                        component="label"
                        htmlFor="username"
                        mb="5px"
                    >
                        Sub-categories <ReqField />
                    </Typography>
                    <Box style={{ display: 'flex', gap: '1rem' }}>
                        <CustomTextField
                            id="username"
                            variant="outlined"
                            fullWidth
                            value={subCategoryValue}
                            onChange={(e) => setSubCategoryValue(e.target.value)}
                            onKeyPress={handleInputKeyPress}
                            name="subcategory"
                        />
                        <Button variant="contained" color="primary" onClick={addSubcategory}>
                            Add
                        </Button>
                    </Box>
                </Box>
                {
                    formData?.subcategories?.length > 0 &&
                    <Box style={{ marginTop: '20px' }}>
                        <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            component="label"
                            htmlFor="username"
                            mb="5px"
                        >
                            Subcategories:
                        </Typography>
                        {
                            formData?.subcategories?.map((item, index) =>
                                <Chip
                                    sx={{
                                        px: "4px",
                                        mx: "4px",
                                        backgroundColor: 'primary.main',
                                        color: "#fff",
                                    }}
                                    size="small"
                                    key={index}
                                    label={item}
                                    onDelete={() => handleDeleteSubcategory(item)}
                                    deleteIcon={<Cancel style={{ color: 'white' }} />}
                                ></Chip>
                            )
                        }
                    </Box>
                }

                {errorMessage != '' && <ShowErrorMessage message={errorMessage} />}
                {showLoader && <ShowLoader value={showLoader} />}
                {successMEssage != '' && <ShowSuccess message={successMEssage} />}

                <div style={{ width: '60%', margin: 'auto', marginTop: '2rem' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
        </PageContainer>
    )
}

export default AddCategory;